import React from "react";
import hand from "../../assets/hand.svg";
import { motion } from "framer-motion";
const Data = () => {
  return (
    <div className="home__data">
      <h1 className="home__title">
        Raj Mhatre <img src={hand} alt="hand" />
      </h1>
      <h3 className="home__subtitle">Web Developer</h3>
      <div className="home__description">
        Hello! My name is Raj and I enjoy creating things that live on the
        internet. I like to craft solid and scalable frontend products with
        great user experiences.
      </div>
      <motion.a
        transition={{ duration: 0.1 }}
        whileHover={{
          scale: 1.05,
        }}
        href="#contact"
        className="button button--flex"
      >
        Say Hello{" "}
        <i
          className="uil uil-message button__icon"
          style={{ transform: "rotate(-45deg) translate(2px,-2px)" }}
        ></i>
      </motion.a>
    </div>
  );
};

export default Data;
